// extracted by mini-css-extract-plugin
export default {"content":"Wrong_content__XvuoZ","icon":"Wrong_icon__hXZPt","title":"Wrong_title__gImNC","text":"Wrong_text__W9pKU","back_btn":"Wrong_back_btn__akSic"};